import {useMutation} from '@tanstack/react-query';
import {PostProvidersListParams} from 'domain/usecases/private/authorizations/post-providers-list';
import {PostProvidersList} from '../services/postProvidersList';

export const usePostProvidersListMutation = () =>
	useMutation({
		mutationFn: (params: PostProvidersListParams) => PostProvidersList(params, params.signal),
	});
